module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAABNElEQVRIicWVz2rCQBCHv4gSFsSSQttAPPg6PfdFei7tydKzL+I5r+Ohhf4B00QhiNLtQVM0mc0mmsaBXHaG37e/7M6sgz20tUBrpyxflrSKF1m6UxVSV1yiHejmIScDJNA+pDFAHiT+w/1QwFi5LAIfPRr+fYvAZ6xcVAVY5qTgQgEPyuX+0qPf6xoFlusNk3nES7oiNbhxJAC73T/eXFXY5zaeP754SldiToQo4DPwSx3kY7necP32LroRz2TqDWoBAPq9LlNvIOZEJ3o0rAU4EJy9Ftast6uJOCekWfb5nITx91FiYZyI6w7wQ25QttInKTCZR5UB7OolAPz/7NJa64511Cu2E+D2otjNYZxwFyVGB9mob+U9aeVlzB+8cfQfC8hEjbWnimdR1vHGm1cHAPALskqA7ocgEa0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./assets/images/supplier-icon.png
// module id = 544
// module chunks = 0